export const isVerifyRTLEnabled = () => {
    return process.env.REACT_APP_VP_USE_RTL.toLowerCase() === "true";
};
